import { render, staticRenderFns } from "./format-address-se.vue?vue&type=template&id=230a5e09&"
import script from "./format-address-se.vue?vue&type=script&lang=js&"
export * from "./format-address-se.vue?vue&type=script&lang=js&"
import style0 from "./format-address-se.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports